<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-row
                align="center"
                justify="end"
        >
            <v-col
                    cols="12"
                    sm="8"
                    md="4"
            >
                <v-card class="elevation-12">
                    <div style="height: 0.5rem;">
                        <v-progress-linear
                                v-show="loading"
                                height="8"
                                indeterminate
                                color="primary"
                        ></v-progress-linear>
                    </div>
                    <v-card-text>
                        <v-container>
                            <v-row class="header-image-container">
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-img
                                            src="./../assets/logo.jpg"
                                            lazy-src="./../assets/logo.jpg"
                                            class="grey lighten-2"
                                            max-width="250"
                                    ></v-img>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <p class="text-justify">
                                        {{ $t("requestPasswordReset.helloText") }}
                                    </p>

                                    <v-alert v-show="error" type="error"
                                             transition="scale-transition">
                                        {{error}}
                                    </v-alert>

                                    <v-alert v-show="success" type="success"
                                             transition="scale-transition">
                                        {{success}}
                                    </v-alert>

                                    <v-form @keyup.native.enter="submit">
                                        <v-text-field
                                                autofocus
                                                :label="$t('common.email') + '*'"
                                                name="email"
                                                type="text"
                                                v-model="email"

                                                :error-messages="emailErrors"
                                                @input="$v.email.$touch()"
                                                @blur="$v.email.$touch()"
                                        ></v-text-field>
                                    </v-form>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container>
                            <v-row
                            >
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-btn x-large color="success" class="login-button" :disabled="loading"
                                           @click="submit">{{ $t("requestPasswordReset.go") }}
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <a @click="$router.push({name : 'login'})" class="caption">
                                        {{ $t("requestPasswordReset.joinLink") }}
                                    </a>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {required, email} from 'vuelidate/lib/validators'

    export default {
        name: 'RequestPasswordReset',

        validations: {
            email: {
                required, email
            },
        },

        data: () => ({
            error: null,
            success: null,
            loading: false,

            email: ''
        }),
        computed: {
            emailErrors() {
                const errors = []

                if(!this.$v.email.$dirty) {
                    return errors
                }

                !this.$v.email.required && errors.push(this.$t('common.errors.fieldRequired'))
                !this.$v.email.email && errors.push(this.$t('common.errors.fieldEmailRequired'))
                return errors
            },
        },
        created() {
            const email = this.$route.query.user;

            if(typeof email !== 'undefined') {
                this.email = email;
            }
        },
        methods: {
            submit() {
                this.$v.$touch()
                if(!this.$v.$invalid) {
                    this.loading = true;
                    this.error = null;

                    this.$store.dispatch('requestPasswordReset', {
                        email: this.email
                    }).then(() => {
                        this.$router.push({
                            name: 'requestPasswordResetSuccess',
                            params: {
                                email: this.email
                            }
                        });
                    }).catch((response) => {
                        switch(response.status) {
                            case 404:
                                this.error = this.$t('requestPasswordReset.errors.userNotFound');
                                break;
                        }
                    }).finally(() => {
                        this.loading = false;
                    })
                }
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .login-button {
        width: 100%;
        text-transform: initial;
    }

    .v-card__text {
        padding-bottom: 0 !important;
    }

    .header-image-container {
        height: 75px;
    }
</style>
